// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"b012bf4863fe6795b035","339":"421400d78d47156f4584"}[chunkId] + ".js";
};